<template>
  <div>
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      :showBusinessSelector="false"
      :showBranchSelector="false"
      @update:searchQuery="searchQuery = $event"
    />
    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" md="8" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title">Business List</h4>
              </div>
            </div>

            <div class="iq-card-body">
              <b-overlay :show="loading" rounded="sm" variant="Primary"></b-overlay>
              <b-table
                class="table b-table table-striped"
                :items="filteredLocalizedItems"
                :fields="columns.map(col => col.prop)"
                striped
                ref="table"
              >
                <template  v-for="column in columns" #[`cell(${column.prop})`]="data">
                  <div v-if="!column.isAction">
                    <div class="user-img img-fluid"  v-if="column.isImage && Array.isArray(data.item[column.prop]) " >
                      <b-img
                        v-if="data.item[column.prop].length"
                        :src="data.item[column.prop][0].src"
                        alt="business logo"
                        rounded
                        class=" avatar-100"
                      />
                      <b-img
                        v-else
                        src="@/assets/images/image_Placeholder.png"
                        alt="business logo"
                        rounded
                        class=" avatar-100"
                      />
                    </div>

                    <span v-else>{{
                      data.item[column.prop] || column.default
                    }}</span>
                  </div>

                  <span v-else>
                    <b-button @click="editMenu(data.item)" variant=" iq-bg-success mr-1 " size="sm">
                      <i class="ri-ball-pen-fill"></i>
                    </b-button>
                  </span>
                </template>
              </b-table>
              <div
                class="mt-3 d-flex justify-content-center"
                v-if="!this.searchQuery"
              >
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="fetchBusinessList"
                />
              </div>

              <EmptySearchMessage
                v-if="searchQuery && filteredLocalizedItems.length <= 0"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4" class="">
          <div class="iq-card ">
            <div></div>
            <Create
              v-if="showAdd"
              :isInList="true"
              @onSubmit="fetchBusinessList()"
            />

            <Edit
              v-if="!showAdd && editModel"
              :isInList="true"
              @onSubmit="fetchBusinessList()"
              :model="editModel"
              :showAdd="showAdd"
              @showAddChanged="updateShowAddState"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Create from "./Create.vue";
import TableConfiguration from "./TableConfiguration";
import Edit from "./Edit.vue";
import { core } from "@/config/pluginInit";
import { getBusinessList } from "@/API/BusinessAPIs";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";

export default {
  name: "BusinessList",
  mixins: [TableConfiguration],
  components: { Create, Edit, SearchFilters, EmptySearchMessage },
  data() {
    return {
      loading: false,
      items: [],
      searchQuery: "",
      showAdd: true,
      editModel: null,
      showSearchBox: true
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    getLocalizedData() {
      return this.items.map(item => {
        const localizedData =
          item.locales.find(locale => locale.locale === this.currentLocale) ||
          item.locales[0];
        return {
          ...item,
          name: localizedData?.name || "",
          description: localizedData?.description || ""
        };
      });
    },
    filteredLocalizedItems() {
      return this.getLocalizedData.filter(item =>
        item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  mounted() {
    core.index();
    this.fetchBusinessList();
  },
  methods: {
    async fetchBusinessList(page = 1) {
      this.loading = true;
      try {
        const perPage = this.searchQuery
          ? this.paginationMeta.total
          : this.paginationMeta.per_page;
        const response = await getBusinessList({ "per-page": perPage, page });
        this.items = response.data;
        this.paginationMeta = response.meta;
      } catch (error) {
        console.error(error);
        this.items = [];
      }finally{
        this.loading = false;
      }
    },
    editMenu(model) {
      this.showAdd = false;
      const requiredLocales = ["en", "ar"];
      console.log(model);

      this.editModel = {
        ...model,
        locales: requiredLocales.map(
          locale =>
            model.locales.find(l => l.locale === locale) || {
              locale,
              name: "",
              description: "",
              id: ""
            }
        )
      };
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  }
};
</script>

<style scoped></style>
